'use client'

import  { useEffect, useState, useMemo } from 'react';
import Cookies from 'js-cookie';
import { Profile } from '../models';

export const useNotificationContext = () => {
    // SIGN IN
    const [privateInboxUnreadMessagesCount, setPrivateInboxUnreadMessagesCount] = useState<number>(0);
    const [eventsInboxUnreadMessagesCount, setEventsInboxUnreadMessagesCount] = useState<number>(0);
    const [privateAndEventsInboxUnreadMessagesCount, setPrivateAndEventsInboxUnreadMessagesCount] = useState<number>(0);
    const [friendRequestsCount, setFriendRequestsCount] = useState<number>(0);

    const contextValue = useMemo(() => ({
        privateInboxUnreadMessagesCount, 
        setPrivateInboxUnreadMessagesCount,
        eventsInboxUnreadMessagesCount, 
        setEventsInboxUnreadMessagesCount,
        privateAndEventsInboxUnreadMessagesCount, 
        setPrivateAndEventsInboxUnreadMessagesCount,
        friendRequestsCount,
        setFriendRequestsCount,
    }), [
        privateInboxUnreadMessagesCount, 
        setPrivateInboxUnreadMessagesCount,
        eventsInboxUnreadMessagesCount, 
        setEventsInboxUnreadMessagesCount,
        privateAndEventsInboxUnreadMessagesCount, 
        setPrivateAndEventsInboxUnreadMessagesCount,
        friendRequestsCount,
        setFriendRequestsCount, 
    ]);

    return contextValue;
    
    // return { 
    //     privateInboxUnreadMessagesCount, 
    //     setPrivateInboxUnreadMessagesCount,
    //     eventsInboxUnreadMessagesCount, 
    //     setEventsInboxUnreadMessagesCount,
    //     privateAndEventsInboxUnreadMessagesCount, 
    //     setPrivateAndEventsInboxUnreadMessagesCount,
    //     friendRequestsCount,
    //     setFriendRequestsCount,
    // }

}

export type NotificationContextValue = ReturnType<typeof useNotificationContext>;